/**
 * Tailwind classes for `EmptyState`, built only from the tokens in
 * `src/styles/globals.css`. No raw hex values and no default palette.
 */
export const emptyStateStyles = {
  root: 'flex flex-col items-center justify-center gap-2 rounded-surface border border-border bg-surface-raised px-6 py-10 text-center',
  title: 'text-sm font-medium text-content',
  description: 'text-sm text-content-muted',
  action: 'mt-2',
} as const;
